export const PAYMENT_METHODS = {
  EFT: 'EFT',
  KAZANG_MOBILE: 'Kazang',
  KAZANG_VCD: 'Kazang VCD',
  DPO: 'DPO'
}

export const PAYMENT_METHOD_CONFIG = {
  [PAYMENT_METHODS.EFT]: {
    id: 'eft',
    label: 'Bank / EFT',
    description: 'Pay via bank transfer using the reference provided',
    icon: 'classic.jpg',
    buttonClass: 'btn-outline-primary'
  },
  [PAYMENT_METHODS.KAZANG_MOBILE]: {
    id: 'kazang-mobile',
    label: 'Mobile Money',
    description: 'Pay instantly with MTN, Airtel, or Zamtel mobile money',
    icon: 'Kazang.png',
    buttonClass: 'btn-outline-info'
  },
  [PAYMENT_METHODS.KAZANG_VCD]: {
    id: 'kazang-vcd',
    label: 'Kazang Vendor Deposit',
    description: 'Use your Kazang vendor account balance',
    icon: 'Kazang.png',
    buttonClass: 'btn-outline-success'
  },
  [PAYMENT_METHODS.DPO]: {
    id: 'dpo',
    label: 'Pay Online Now',
    description: 'Pay securely online with card or mobile money',
    icon: 'dpo.png',
    buttonClass: 'btn-success',
    hasDiscount: true,
    discountPercentage: window.DPO_DISCOUNT * 100
  }
}

export const BANK_DETAILS = {
  bankName: 'FNB',
  accountName: 'Chrilan Technology Limited',
  accountType: 'Business Cheque Account',
  accountNumber: '62812689521',
  branchName: 'Commercial',
  branchCode: '260001',
  swiftCode: 'FIRNZMLX'
}
